document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.klaviyo-popup-wrp');
  const emailContainer = popup.querySelector('.klaviyo-popup-container.email');
  const phoneContainer = popup.querySelector('.klaviyo-popup-container.phone');
  const thankYouContainer = popup.querySelector('.klaviyo-popup-container.thank-you');

  const emailInput = popup.querySelector('.klaviyo-popup-email');
  const phoneInputContainer = popup.querySelector('.klaviyo-popup-phone-input-container');
  const phoneInput = popup.querySelector('.klaviyo-popup-phone-input');
  const phoneCountry = popup.querySelector('.klaviyo-popup-phone-country');
  const agreeCheckbox = popup.querySelector('#email-phone');
  const agreeCheckboxLabel = popup.querySelector('#email-phone-label');

  const submitEmailBtn = popup.querySelector('.klaviyo-popup-button-submit.email');
  const submitPhoneBtn = popup.querySelector('.klaviyo-popup-button-submit.phone');

  const closeBtns = popup.querySelectorAll("[name='close-popup'], .klaviyo-popup-phone-close-button");

  const errorPopup = popup.querySelector('.error-popup');
  const emptyErrorText = errorPopup.querySelector('.error-popup-content-text.empty');
  const unvalidErrorText = errorPopup.querySelector('.error-popup-content-text.unvalid');

  const useContainer = popup.querySelector('.klaviyo-popup-container.use');
  const submitUseBtn = popup.querySelector('.klaviyo-popup-button-submit.use');
  const emailSubscribeCheckbox = popup.querySelector('#email-subscribe'); // FR email consent
  const emailSubscribeLabel = popup.querySelector('#email-subscribe-label'); // FR email consent

  let popupTriggered = false;

  function setPopupClosed() {
    localStorage.setItem('klaviyo_popup_closed', 'true');
  }

  function isPopupClosed() {
    return localStorage.getItem('klaviyo_popup_closed') === 'true';
  }

  function lockScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
  }

  function showPopup() {
    if (popupTriggered || isPopupClosed()) return;
    popup.classList.add('active');
    lockScroll();
    popupTriggered = true;
  }

  function hidePopup() {
    popup.classList.remove('active');
    unlockScroll();
  }

  setTimeout(function () {
    showPopup();
  }, 21000);

  window.addEventListener('scroll', function () {
    if (popupTriggered || isPopupClosed()) return;
    const scrollPercent = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    if (scrollPercent > 40) {
      showPopup();
    }
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      hidePopup();
      setPopupClosed();
    });
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  function showErrorPopup() {
    errorPopup.classList.add('active');
    setTimeout(function () {
      errorPopup.classList.remove('active');
    }, 4000);
  }

  function setErrorTexts(isEmpty, errorfieldsName) {
    if (isEmpty) {
      emptyErrorText.style.display = 'block';
      unvalidErrorText.style.display = 'none';
      emptyErrorText.textContent = emptyErrorText.textContent.replace('""', '"' + errorfieldsName + '"');
    } else {
      unvalidErrorText.style.display = 'block';
      unvalidErrorText.textContent = unvalidErrorText.textContent.replace('""', '"' + errorfieldsName + '"');
    }
    showErrorPopup();
  }

  async function sendPopupDataToKlaviyo(email, phone, usage = null) {
    let language = 'EN';

    if (window.KL_LANGUAGE === 'fr') {
      language = 'FR';
    } else if (window.KL_LANGUAGE === 'de') {
      language = 'DE';
    }

    const payload = {
      $email: email || undefined,
      $phone_number: phone || undefined,
      Language: language,
      agreeSMS: agreeCheckbox?.checked || false,
      emailSubscribe: emailSubscribeCheckbox?.checked || false,
      ...(usage ? { usage } : {}),
    };

    try {
      // Identify + Track
      await klaviyo.identify(payload);
      await klaviyo.track('Popup Submission', payload);
    } catch (e) {
      console.warn('Klaviyo identify/track error:', e);
    }

    // Base options for API calls
    const requestOptions = (body) => ({
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-10-15',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify(body),
    });

    const API_URL = 'https://a.klaviyo.com/client/subscriptions?company_id=UQzMTp';

    // ✅ Email subscription
    if (email) {
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: { newKey: 'New Value' },
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } },
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: 'RwNhZj' } },
          },
        },
      };

      try {
        await fetch(API_URL, requestOptions(body));
      } catch (e) {
        console.warn('Klaviyo email subscription error:', e);
      }
    }

    // ✅ SMS subscription
    if (payload.agreeSMS && phone) {
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  phone_number: phone,
                  properties: { newKey: 'New Value' },
                  subscriptions: {
                    sms: { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } },
                    whatsapp: { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } },
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: 'SKwn4X' } },
          },
        },
      };

      try {
        await fetch(API_URL, requestOptions(body));
      } catch (e) {
        console.warn('Klaviyo SMS subscription error:', e);
      }
    }
  }

  submitEmailBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    const email = emailInput.value.trim();

    if (email.length < 5 && emailSubscribeCheckbox && !emailSubscribeCheckbox.checked) {
      emailInput.classList.add('error');
      emailSubscribeLabel.classList.add('error');
      setErrorTexts(true, 'Email, Checkbox');
      return;
    } else if (email.length < 5) {
      emailInput.classList.add('error');
      setErrorTexts(true, 'Email');
      return;
    } else if (emailSubscribeCheckbox && !emailSubscribeCheckbox.checked) {
      emailSubscribeLabel.classList.add('error');
      setErrorTexts(true, 'Email');
      return;
    } else if (!isValidEmail(email)) {
      emptyErrorText.style.display = 'none';
      setErrorTexts(false, 'Email');
      return;
    }

    emailInput.classList.remove('error');
    if (emailSubscribeCheckbox) emailSubscribeCheckbox.classList.remove('error');

    setPopupClosed();
    sendPopupDataToKlaviyo(email, '');

    if (useContainer) {
      emailContainer.classList.add('hidden');
      useContainer.classList.remove('hidden');
    } else {
      emailContainer.classList.add('hidden');
      phoneContainer.classList.remove('hidden');
    }
  });

  if (submitUseBtn && useContainer) {
    submitUseBtn.addEventListener('click', function () {
      const selected = popup.querySelector("input[name='use']:checked");

      if (!selected) {
        setErrorTexts(true, 'Usage');
        return;
      }

      sendPopupDataToKlaviyo(emailInput.value.trim(), '', selected.value);

      useContainer.classList.add('hidden');
      phoneContainer.classList.remove('hidden');
    });
  }

  submitPhoneBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    const phone = phoneInput.value.trim();
    const prefix = phoneCountry.value;

    if (!agreeCheckbox.checked && phone.length < 6) {
      phoneInputContainer.classList.add('error');
      agreeCheckboxLabel.classList.add('error');
      setErrorTexts(false, 'Phone, Checkbox');
      return;
    } else if (!agreeCheckbox.checked) {
      agreeCheckboxLabel.classList.add('error');
      setErrorTexts(false, 'Checkbox');
      return;
    } else if (phone.length < 6 && phone.length != 0) {
      phoneInputContainer.classList.add('error');
      setErrorTexts(false, 'Phone');
      return;
    } else if (phone.length == 0) {
      phoneInputContainer.classList.add('error');
      setErrorTexts(true, 'Phone');
      return;
    }

    agreeCheckboxLabel.classList.remove('error');
    phoneInputContainer.classList.remove('error');

    sendPopupDataToKlaviyo(emailInput.value.trim(), prefix + phone);

    phoneContainer.classList.add('hidden');
    thankYouContainer.classList.remove('hidden');
    setPopupClosed();
  });
});
